<template>
    <div id="app">
        <ring-loader color="#0080C5" class="ring-loader" :loading="isLoading"></ring-loader>

        <flash-message></flash-message>

        <transition name="component-fade" mode="out-in">
            <component v-bind:is="layout"></component>
        </transition>
    </div>
</template>

<script>
    import Blank from "./components/layouts/Blank";
    import Base from "./components/layouts/Base";

    export default {
        name: 'application',
        data() {
            return {
                isLoading: true,
                timerLogoff: undefined,
                timerLogoffInMillesimus: 36000, // 10 minutos
            };
        },
        computed: {
            layout() {
                var routeName = "" + this.$route.name;
                if (routeName === 'login') {
                    return "blank-layout";
                } else {
                    if (routeName !== null) {
                        if (routeName.indexOf("reports.print") === 0) {
                            return "blank-layout";
                        } else {
                            return "base-layout";
                        }
                    }
                }
            }
        },
        methods: {
            changeStateLoading: function () {
                this.isLoading = !this.isLoading;
            },
            // resetTimerLogoff: function() {
            //     clearTimeout(this.timerLogoff);
            // },
            // restartTimerLogoff: function() {
            //     var self = this;

            //     if (typeof this.timerLogoff === "number") {
            //         self.resetTimerLogoff();
            //     }

            //     self.timerLogoff = setTimeout(
            //         () => {
            //             self.$store.dispatch('auth/logout');
            //             self.$router.push({name: 'login'});
            //             self.isLoading = false;
            //         },
            //         self.timerLogoffInMillesimus
            //     );
            // },
        },
        mounted() {
            var self = this;

            self.$root.$on("onLoading", self.changeStateLoading);
            // self.$root.$on("restartTimerLogoff", self.restartTimerLogoff);
            
            self.changeStateLoading();
            // self.restartTimerLogoff();
        },
        components: {
            "blank-layout": Blank,
            "base-layout": Base,
        }
    }
</script>

<style>
    .loading {
        margin: 0;
        z-index: 99999;
        position: absolute;
        top: 40%;
        left: 46%;
        margin-right: -50%;
        opacity: 1;
        transition: all 2s;
    }

    .loading.hide {
        opacity: 0;
        transition: all 2s;
    }
</style>
